var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddConnectCame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 4.66602C5.73541 4.66602 4.66675 5.73468 4.66675 6.99935C4.66675 8.26402 5.73541 9.33268 7.00008 9.33268C8.26475 9.33268 9.33341 8.26402 9.33341 6.99935C9.33341 5.73468 8.26475 4.66602 7.00008 4.66602ZM7.00008 8.16602C6.37883 8.16602 5.83341 7.6206 5.83341 6.99935C5.83341 6.3781 6.37883 5.83268 7.00008 5.83268C7.62133 5.83268 8.16675 6.3781 8.16675 6.99935C8.16675 7.6206 7.62133 8.16602 7.00008 8.16602Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.91602H10.1582L8.57916 1.33693C8.52509 1.28266 8.46081 1.23962 8.39003 1.21028C8.31925 1.18095 8.24337 1.16591 8.16675 1.16602H5.83342C5.7568 1.16591 5.68092 1.18095 5.61014 1.21028C5.53936 1.23962 5.47508 1.28266 5.421 1.33693L3.84191 2.91602H2.33341C1.69 2.91602 1.16675 3.43927 1.16675 4.08268V10.4993C1.16675 11.1428 1.69 11.666 2.33341 11.666H11.6667C12.3102 11.666 12.8334 11.1428 12.8334 10.4993V4.08268C12.8334 3.43927 12.3102 2.91602 11.6667 2.91602ZM2.33341 10.4993V4.08268H4.08342C4.23858 4.08268 4.38675 4.02143 4.49583 3.91177L6.07491 2.33268H7.92525L9.50433 3.91177C9.55841 3.96604 9.62269 4.00908 9.69347 4.03842C9.76425 4.06775 9.84013 4.08279 9.91675 4.08268H11.6667L11.6679 10.4993H2.33341Z",
    fill: "#333333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConnectCame);
export default __webpack_public_path__ + "static/media/addConnectCame.71aefd5237ff43c0c528112b0d130780.svg";
export { ForwardRef as ReactComponent };